import React from 'react'
import { Autocomplete, Button, TextField, createFilterOptions, useObservable } from '@cicero/ui'
import { AttributeDoc, AttributeSchema, AttributeType, useModel } from '../../models'
import { IEditorCell, IEditorCellEditableArgs } from './types'

const filterAttributeValidators = createFilterOptions<AttributeDoc>()

export const AttributeChooser = ({ value, setValue }: IEditorCellEditableArgs<AttributeDoc|null>) => {
  const Attributes = useModel(AttributeSchema)
  const options = useObservable(() => Attributes.QUERY$({ selector: {} }), [], []) // TODO Actually apply search?

  return <Autocomplete
    value={value}
    options={options}
    getOptionLabel={(v) => v.label}
    // renderOption={(o) => o.}
    selectOnFocus
    clearOnBlur
    handleHomeEndKeys
    freeSolo
    renderInput={(params) => <TextField {...params} autoFocus placeholder="Enter Attribute Name" />}
    onChange={async (event, newValue) => {
      const { action } = newValue as any
      if (action) {
        const key = action.toLowerCase() // TODO Validate
        const v = await Attributes.CREATE({ label: action, key, owner_id: 'lexholden', type: AttributeType.text })
        setValue(v)
      } else if (typeof newValue === 'string') {
        return
      } else {
        setValue(newValue)
      }
    }}
    filterOptions={(opts, params) => {
      // LOGGER.debug({ opts, params, options })
      if (params.inputValue === '') { return opts }
      const filtered = filterAttributeValidators(opts, params)
      filtered.push({
        action: params.inputValue,
        label: `Add New Attribute "${params.inputValue}"`,
      } as any)
      return filtered
    }}
  />
}

export const AttributeLabelCellRenderer: IEditorCell<AttributeDoc|null> = {
  id: 'attribute-label',
  description: 'Choose an attribute validator based on its label, or add a new one',
  editOn: 'singleclick',
  renderer: ({ value: attribute }: { value:  AttributeDoc|null }) => {
    return attribute ? <strong>{attribute.label}</strong> : <Button>Add Attribute...</Button>
  },
  editableRenderer: AttributeChooser,
}
